export default {
  nav: {
    coreLogic: 'コアロジック',
    profitMechanism: '収益メカニズム',
    profitFlywheel: '収益フライホイール',
    sysArch: 'システムアーキテクチャ',
    tradingExample: '取引事例',
    cta: '始める',
    language: '言語',
  },
  hero: {
    badge: 'Poly Ai Claw インテリジェンスエンジン',
    title1: '予測から',
    title2: '確率裁定取引へ',
    desc: 'PolywinはPoly Ai Clawインテリジェンスエンジンを通じて予測市場を体系的な裁定取引エンジンにアップグレードします',
    ctaPrimary: 'Poly Ai Clawエンジンを起動',
    ctaSecondary: 'デモを見る',
    statsEvents: '監視イベント',
    statsSuccessRate: '実行成功率',
    statsExecTime: '実行時間',
    cardTitle: '確率偏差分析',
    cardBadge: 'EVエッジゾーン',
    cardMarketProb: '市場確率',
    cardAiProb: 'AI確率',
    cardMarketImplied: '市場内在確率',
    cardAiTrue: 'AI真実確率',
    cardProbDiff: '確率エッジ',
  },
  coreLogic: {
    badge: 'PolyAi-Claw決定システム',
    title1: 'データ集約から複利収益まで',
    title2: '完全自動化ループ',
    desc: 'マルチソースデータ → AIモデリング → 確率偏差 → 自動実行 → 複利収益の完全自動化取引ループ',
    step0_title: 'データレイヤー',
    step0_sub: 'マルチソース集約',
    step0_i0: '政治イベント',
    step0_i1: 'マクロ経済',
    step0_i2: 'ソーシャルセンチメント',
    step0_i3: '板データ',
    step1_title: 'AIモデリング',
    step1_sub: 'ベイズ確率更新',
    step1_i0: 'リアルタイムデータ入力',
    step1_i1: 'AIモデリングエンジン',
    step1_i2: '確率計算',
    step1_i3: 'モデル最適化',
    step2_title: '偏差検出',
    step2_sub: '確率偏差識別',
    step2_i0: '市場内在確率',
    step2_i1: 'AI真実確率',
    step2_i2: 'EVエッジ検出',
    step2_i3: 'ポジションシグナル',
    step3_title: 'オンチェーン実行',
    step3_sub: 'Polygon自動取引',
    step3_i0: 'リスク管理',
    step3_i1: '資金配分',
    step3_i2: 'USDC決済',
    step3_i3: 'スマートコントラクト',
    step4_title: '複利収益',
    step4_sub: '自動再投資',
    step4_i0: 'イベント決済',
    step4_i1: '利益清算',
    step4_i2: '複利計算',
    step4_i3: '再投資ループ',
    keyTitle: 'コア目標',
    keyDesc: 'PolyAi-Clawの目標は、市場における確率の誤価格（Mispricing）を継続的に発見し、体系的な裁定取引を実行することです。',
    keyHighlight: '確率の誤価格を継続的に発見し体系的な裁定取引を実行',
  },
  profitMechanism: {
    badge: 'コア収益メカニズム',
    title1: 'PolyAi-Clawの',
    title2: '3つの収益メカニズム',
    desc: 'EVエッジ検出、ミリ秒実行、3段階資金管理で安定した確率裁定取引システムを構築',
    m1_title: 'EVエッジ検出',
    m1_sub: 'Probability Edge Detection',
    m1_desc: 'コアロジック：市場価格 ≠ 真実確率。AIが市場内在確率と真実確率の偏差を検出すると、自動的にEVエッジゾーンに入りポジションをトリガーします。',
    m1_marketImplied: '市場内在確率',
    m1_aiTrue: 'AI真実確率',
    m1_probDiff: '確率エッジ',
    m1_note: 'クオンツファンドのオプション裁定取引と同じ原理',
    m2_title: 'ミリ秒自動実行',
    m2_sub: 'Millisecond Execution',
    m2_desc: '完全自動化実行フレームワークにより、人的ミスによる裁定取引機会の損失を防ぎます。',
    m2_i0_title: 'ミリ秒実行速度',
    m2_i0_sub: '平均 <200ms',
    m2_i1_title: '完全オンチェーン透明',
    m2_i1_sub: 'Polygon PoS',
    m2_i2_title: '人的干渉なし',
    m2_i2_sub: 'スマートコントラクト自動決済',
    m2_network_label: '実行ネットワーク',
    m2_network_val: 'Polygon + USDC',
    m3_title: '3段階資金管理',
    m3_sub: 'Three-Tier Risk Control',
    m3_desc: '伝統的な投機の高レバレッジと単点リスクを回避する3層資金構造。',
    m3_i0_title: '安定収益プール',
    m3_i0_desc: '高確実性確率裁定、最低リスク',
    m3_i1_title: 'ボラティリティ裁定プール',
    m3_i1_desc: '市場ボラティリティを捕捉、高い収益弾力性',
    m3_i2_title: 'ヘッジ保護プール',
    m3_i2_desc: '低相関イベントヘッジ、システムリスク低減',
    m3_risk: '単一イベントエクスポージャー < 5%',
    formula_title: '確率裁定取引公式',
    formula_marketPrice: '市場価格',
    formula_aiTrue: 'AI真実確率',
    formula_trigger: 'ポジショントリガー',
    formula_arbitrage: '裁定取引',
    formula_hiddenPct: '内在60%',
    formula_evEdge: 'EVエッジ +12%',
    formula_autoExec: '自動実行',
  },
  fundManagement: {
    riskTitle: 'コアリスク管理原則',
    riskDesc: 'システムは単一イベント最大エクスポージャー < 5%を設定し、単一イベントの極端な結果がファンド全体に大きな影響を与えないようにします。',
    riskHighlight: '単一イベント最大エクスポージャー < 5%',
    stat_maxSingle: '最大単一投資',
    stat_maxSingleVal: '5%',
    stat_diversify: '資金分散',
    stat_diversifyVal: '20+イベント',
    stat_stopLoss: '損切りメカニズム',
    stat_stopLossVal: '自動トリガー',
    vizTitle: 'リスク管理可視化',
    viz_exposure: 'エクスポージャー管理',
    viz_diversify: '資金分散',
    viz_correlation: 'イベント相関',
    viz_stability: '戦略安定性',
  },
  techAdvantage: {
    badge: 'コアアドバンテージ',
    title1: 'なぜPolyAi-Clawは',
    title2: '従来の予測市場より優れているのか？',
    dim_decision: '意思決定基盤',
    dim_monitor: '監視頻度',
    dim_execute: '実行方法',
    dim_model: '認知モデル',
    dim_risk: 'リスク管理',
    human_decision: '感情主導',
    human_monitor: '低頻度',
    human_execute: '手動注文',
    human_model: '主観的',
    human_risk: '経験ベース',
    ai_decision: 'データ主導',
    ai_monitor: '高頻度',
    ai_execute: '自動実行',
    ai_model: '確率モデル',
    ai_risk: 'アルゴリズム管理',
    humanPredict: '人間の予測',
    adv1_title: 'データ主導 vs 感情主導',
    adv1_desc: 'PolyAi-Clawは政治イベント、マクロ経済、ソーシャルセンチメント、板データを含むマルチソースデータでモデリングします。',
    adv1_label: 'データソース数',
    adv2_title: '高頻度 vs 低頻度',
    adv2_desc: 'システムは24/7中断なく市場変化を監視し、確率偏差の機会をリアルタイムで識別します。',
    adv2_label: '監視頻度',
    adv3_title: '自動実行 vs 手動注文',
    adv3_desc: 'Polygonチェーンのスマートコントラクトによるミリ秒自動実行で遅延やミスなく裁定機会を逃しません。',
    adv3_label: '実行速度',
    adv4_title: 'アルゴリズム管理 vs 経験ベース',
    adv4_desc: '3段階資金管理システムで単一イベントエクスポージャーを5%以下に厳格に管理。',
    adv4_label: 'リスク管理',
    conclusion_title: '予測市場からPoly Ai Clawインテリジェンスエンジンへ',
    conclusion_desc1: 'これによりPolyWinはシンプルなPrediction Marketからアップグレードされます',
    conclusion_brand: 'Poly Ai Clawインテリジェンスエンジン',
    conclusion_desc2: 'Poly Ai Clawクオンツ予測システム',
  },
  productNarrative: {
    badge: '製品ポジショニング',
    title: 'PolyWinの真のアイデンティティ',
    desc: 'PolyWinは単純な予測市場ではなく、AI、予測市場、OpenClaw、クオンツ取引を統合した総合システムです。',
    item0_title: '確率裁定取引システム',
    item0_sub: '市場の誤価格を継続的に捕捉',
    item1_title: '規律ある実行モデル',
    item1_sub: '自動化、感情介入なし',
    item2_title: 'AIリスク管理エンジン',
    item2_sub: 'インテリジェントリスク管理',
    visual_title: '3つのビジュアル表現',
    vis0_title: '① 確率曲線偏差チャート',
    vis0_desc: 'AI確率曲線 vs 市場価格曲線を示す明確な価格偏差領域',
    vis0_ai: 'AI確率',
    vis0_market: '市場価格',
    vis0_diff: '確率差',
    vis1_title: '② リスク管理レーダーチャート',
    vis1_desc: 'リスクエクスポージャー、資金分散、イベント相関、戦略安定性を表示',
    vis1_exposure: 'リスクエクスポージャー',
    vis1_diversify: '資金分散',
    vis1_safe: 'セーフゾーン',
    vis1_safeVal: '進入済み',
    vis2_title: '③ AI自動取引フロー図',
    vis2_desc: 'データ → AI → 実行 → 決済 → 複利の完全なループ',
    vis2_exec: '実行速度',
    vis2_execVal: 'ミリ秒',
    vis2_auto: '自動化率',
    vis2_compound: '複利ループ',
    vis2_compoundVal: '継続',
    core_title: 'コアバリュープロポジション',
    core_desc: '自動化確率価格設定と時間複利メカニズムを通じて、PolyAi-Clawはリスク管理を確保しながら予測市場の価格偏差を継続的に捕捉します。',
    core_highlight: '自動化確率価格設定と時間複利メカニズム',
    core_item0: '自動化確率価格設定',
    core_item1: '時間複利メカニズム',
    core_item2: 'リスク管理保証',
    core_item3: '継続的偏差捕捉',
  },
  profitFlywheel: {
    badge: 'AI駆動金融成長フライホイール',
    title1: 'PolyWin AI',
    title2: '収益フライホイールモデル',
    desc: 'PolyWinの成長は単一取引の利益に依存せず、AI駆動の継続的複利システムに依存します',
    descHighlight: 'AI駆動の継続的複利システム',
    aiCore: 'AI Probability Engine',
    step1_title: 'グローバルデータ入力',
    step1_sub: 'Global Data',
    step1_desc: 'AIがニュースイベント、政治変化、マクロ経済データ、ソーシャルセンチメントを継続監視',
    step1_tech: '50+データソース',
    step1_techDetail: 'マルチソースリアルタイム融合',
    step2_title: 'AI確率モデリング',
    step2_sub: 'Probability Modeling',
    step2_desc: 'ベイズ確率モデル、センチメント修正モデル、市場価格モデルで真実確率を計算',
    step2_tech: 'ベイズモデル',
    step2_techDetail: '動的確率リアルタイム修正',
    step3_title: '確率偏差を発見',
    step3_sub: 'Probability Edge',
    step3_desc: 'AI真実確率 > 市場内在確率の時、EV Positive Opportunityとして識別',
    step3_tech: 'EV偏差 >5%',
    step3_techDetail: '正期待値自動検出',
    step4_title: '自動取引実行',
    step4_sub: 'Algorithmic Execution',
    step4_desc: 'システムがポジション構築、ヘッジ、注文実行を自動完了',
    step4_tech: 'スマートコントラクト',
    step4_techDetail: '<200msミリ秒実行',
    step5_title: '予測市場収益',
    step5_sub: 'Market Profit',
    step5_desc: 'イベント結果確認または市場確率回帰時に裁定収益を獲得',
    step5_tech: 'Polygon PoS',
    step5_techDetail: 'オンチェーン自動決済',
    step6_title: '資金回収',
    step6_sub: 'Capital Recycling',
    step6_desc: 'システムが利益資金を自動的にファンドプールに回収',
    step6_tech: 'USDC決済',
    step6_techDetail: 'ステーブルコイン為替損失なし',
    step7_title: '複利成長',
    step7_sub: 'Compounding Capital',
    step7_desc: 'ファンドプール規模拡大後、AIはより大きな市場に参加可能',
    step7_tech: '自動複利',
    step7_techDetail: '利益自動再投資ループ',
    step8_title: 'より大きな資金規模',
    step8_sub: 'Larger Liquidity Pool',
    step8_desc: 'より大きな資金規模はより高い取引能力と安定した収益を意味する',
    step8_tech: '流動性拡大',
    step8_techDetail: '規模が大きいほど優位性が増す',
    sum0_label: 'データレイヤー',
    sum0_tech: '50+マルチソースストリーム',
    sum0_detail: 'ベイズリアルタイムモデリング',
    sum1_label: '実行レイヤー',
    sum1_tech: 'スマートコントラクト自動化',
    sum1_detail: 'Polygon PoSオンチェーン決済',
    sum2_label: '決済レイヤー',
    sum2_tech: 'USDCステーブルコイン',
    sum2_detail: '為替損失なし決済',
    sum3_label: '複利レイヤー',
    sum3_tech: '自動再投資',
    sum3_detail: '規模拡大正循環',
    key0_title: '自己強化ループ',
    key0_desc: '毎回の利益がシステム能力を強化し、指数関数的成長を実現',
    key1_title: 'AI駆動成長',
    key1_desc: '成長は紹介に依存せず、AIシステム自身の確率裁定能力に依存',
    key2_title: '継続複利システム',
    key2_desc: '自動化利益回収と再投資でファンド規模が継続拡大',
    formula_title: 'フライホイール成長公式',
    f0_label: 'AIデータ',
    f1_label: '確率裁定',
    f2_label: '利益',
    f3_label: '複利',
    f4_label: 'より多くの資金',
    f5_label: 'より多くの裁定',
    connected: '接続済み · リアルタイム',
  },
  sysArch: {
    badge: 'Official Architecture',
    title1: 'PolyAi-Claw AI',
    title2: 'システムアーキテクチャ',
    desc: 'データ収集から自動決済までの完全なAI意思決定システム',
    coreBadge: 'コアAIブレイン',
    feat0_title: '完全なAIシステム構造',
    feat0_desc: '単純な戦略ではなく、データ収集から自動実行までの完全なAI意思決定システム',
    feat1_title: 'クオンツファンド級リスク管理',
    feat1_desc: 'エクスポージャー管理、相関ヘッジ、動的資金配分を含む専門クオンツファンドのリスク管理モデル',
    feat2_title: 'スケーラブルアーキテクチャ',
    feat2_desc: 'マルチマーケット、マルチチェーン、マルチ戦略への拡張が可能',
    dataflow_title: 'データフロー',
  },
  tradingExample: {
    badge: '実戦ケーススタディ',
    title1: 'PolyAi-Claw BTC',
    title2: '5分裁定取引戦略',
    desc: 'システムは3つだけ：異常ボラティリティ検出 → 最後60秒確率判断 → セーフゾーン取引',
    s1_title: 'BTC Market Data',
    s1_sub: 'リアルタイム市場監視',
    s1_notice: '戦略トリガー条件のサンプルデータ',
    s1_price: '現在価格',
    s1_eg: '例',
    s1_priceVol: '価格ボラティリティ',
    s1_vol: '取引量',
    s1_depth: '板の深さ',
    s1_trigger: 'トリガー：ボラティリティ ≥ 100 USD',
    s1_met: '満たされた',
    s2_title: 'PolyAi-Claw Engine',
    s2_sub: 'AI確率計算',
    s2_marketImplied: '市場内在確率',
    s2_aiTrue: 'AI真実確率',
    s2_yes: 'YES',
    s2_probDiff: '確率エッジ',
    s2_safe: 'セーフ取引ゾーンに進入',
    s3_title: 'Auto Trade + Profit',
    s3_sub: '自動実行と収益',
    s3_exec: '取引実行',
    s3_buyYes: 'YES買い',
    s3_buyPrice: '買値',
    s3_settlement: '予測市場決済',
    s3_correct: '正確な予測',
    s3_profit: '取引ごとの収益',
    s3_avg: '平均収益率',
    s3_recycle: 'プールに収益回収',
    chart_title: 'AI確率 vs 市場確率偏差チャート',
    chart_sub: 'Poly Ai Clawエンジン vs 市場価格確率偏差のリアルタイム追跡',
    chart_live: 'Live Analysis',
    chart_curDev: '現在の偏差',
    chart_signal: '裁定シグナル',
    chart_signalVal: 'トリガー済み',
    chart_winRate: '勝率予測',
    chart_bottom_implied: '市場内在確率',
    chart_bottom_dev: '確率偏差ゾーン',
    chart_bottom_dev_sub: '裁定機会トリガー済み',
    chart_bottom_ai: 'AI真実確率',
    chart_bottom_ai_sub: 'Poly Ai Clawモデル出力',
    chart_bottom_implied_sub: '市場価格ベース',
    chart_marketProb: '市場内在確率',
    chart_aiProb: 'AI真実確率',
    chart_deviationArea: '裁定偏差ゾーン',
    maxDeviation: '最大偏差',
    deviation: '偏差',
    flow_title: '完全な戦略フロー',
    flow0_title: 'BTCデータ監視',
    flow0_desc: 'リアルタイム価格/取引量',
    flow1_title: 'ボラティリティ検出',
    flow1_desc: '≥ 100 USD',
    flow2_title: '時間フィルター',
    flow2_desc: '最後60秒',
    flow3_title: '勝率評価',
    flow3_desc: '≥ 60-70%',
    flow4_title: '自動実行',
    flow4_desc: 'YES/NO買い',
    flow5_title: '市場決済',
    flow5_desc: '1 USDC',
    flow6_title: '複利収益',
    flow6_desc: '3%-10%',
    risk0_title: 'リスク管理構造',
    risk0_i0: '単一イベント資金制限 < 5%',
    risk0_i1: 'マルチイベント分散',
    risk0_i2: 'AI動的損切り',
    risk1_title: 'タイミング戦略',
    risk1_i0: '最後60秒で実行',
    risk1_i1: '感情的取引を避ける',
    risk1_i2: 'より完全な情報',
    risk2_title: '過去のパフォーマンス',
    risk2_i0: '過去勝率 80%-90%',
    risk2_i1: '平均収益 3%-10%',
    risk2_i2: '安定した裁定モデル',
  },
  crossPlatform: {
    badge: 'クロスプラットフォーム予測裁定',
    title1: 'PolyAi CLaw',
    title2: 'クロスプラットフォーム予測市場裁定ロジック',
    desc: 'Polymarket(Web3)とKalshi(法定通貨)を橋渡し、価格偏差を捕捉し、インテリジェントマッチング + 超高速実行',
    polymarket: 'Polymarket',
    kalshi: 'Kalshi',
    web3: 'Web3',
    fiat: '法定通貨',
    claw: 'CLaw',
    matched: '✓ マッチング済み',
    matching: 'マッチング中...',
    sec1_badge: '01',
    sec1_accuracy: '99%+精度',
    sec1_title: 'インテリジェント市場マッチング',
    sec1_desc: '両プラットフォームのイベントがセマンティックAIによって自動バインドされます',
    sec2_badge: '02',
    sec2_ms: 'ミリ秒実行',
    sec2_title: '統合接続と超高速取引',
    sec2_desc: '統合API/SDKでマルチプラットフォーム接続、ミリ秒同期注文で裁定窓口をゼロ遅延で捕捉',
    connected: '接続済み · リアルタイム',
    latency: '注文遅延',
    dailyEvents: '日次マッチングイベント',
    successRate: '実行成功率',
    platforms: '同期プラットフォーム数',
    sec3_badge: '03',
    sec3_analytics: 'Live Analytics',
    sec3_title: '裁定データ可視化',
    sec3_desc: 'リアルタイム価格偏差、裁定収益、成長トレンド',
    priceDeviation: '価格偏差分布',
    volumeTitle: '月次取引量（K USDC）',
    h1Volume: 'H1累計取引量（USDC）',
    arbIndicators: '裁定優位性指標',
    arbSuccess: 'スプレッド裁定成功率',
    semanticAccuracy: 'セマンティックマッチング精度',
    liquidity: 'クロスプラットフォーム流動性',
    hedgeCoverage: 'ヘッジカバレッジ率',
  },
  mathAlgo: {
    badge: '精密高度数学アルゴリズム',
    title1: 'Polymarket裁定は',
    title2: '単純な数学問題ではない',
    quote: 'あなたがまだ手動でこの加算問題を計算している間に、クオンツシステムはすでに全く別のことをしています。',
    quoteHighlight1: '手動で計算',
    quoteHighlight2: '全く別のこと',
    ch0_title: '裁定取引とは？なぜPolymarketにこんなに多いのか？',
    ch0_tag: '市場非効率性',
    ch1_title: 'クロスマーケット裁定：論理的依存関係',
    ch1_tag: '組合せ数学',
    ch2_title: 'Bregman投影：最適裁定量の計算',
    ch2_tag: '凸最適化',
    pipeline_title: 'Polymarket裁定システム — 完全アーキテクチャ',
    layer0: 'レイヤー1：データ収集',
    layer1: 'レイヤー2：依存関係検出',
    layer2: 'レイヤー3：3段階最適化エンジン',
    layer3: 'レイヤー4：実行とポジション管理',
    annualProfit: '年間総抽出利益：$39,688,585',
    venn_title: '論理的依存関係：P(5%大勝) ⊆ P(勝利)',
    contradiction: '矛盾！P(部分集合) > P(全体集合) → 裁定シグナルトリガー',
    contradiction_sub: '0.55 > 0.48 → 論理的矛盾 → 裁定機会',
    combinations: '組合せ数',
    brutal: '総当たり列挙不可能',
    integerConstraints: '整数計画制約',
    replaces: '16,384列挙を代替',
    bregman_title: 'KLダイバージェンス vs ユークリッド距離',
    coreData: 'コアデータ',
    pipeline4: 'システム4レイヤーパイプライン',
    annualReturn: '年間利益 ≈ $3,968万',
    whyNotEnough_title: 'なぜ「価格の合計 = $1」だけでは不十分なのか？',
    singleMarket: '単一市場 — 表面上は正常',
    crossMarket: 'クロスマーケット — 指数関数的爆発',
  },
  mathProfit: {
    ch3_title: 'Frank-Wolfeアルゴリズム：段階的に答えに近づく',
    ch3_tag: '反復アルゴリズム',
    ch3_chapter: '第04章',
    execTitle: '非原子的実行リスク',
    profitStructure: '利益構造（2024.4 – 2025.4）',
    totalProfit: '合計：$39,688,585',
    top10: 'TOP 10が20.5%を占める',
    kellyFormula: '改良Kellyポジション公式',
    preTrade: '取引前4つのチェックポイント',
    gate0: '流動性は十分か？',
    gate1: 'スリッページは許容範囲か？',
    gate2: 'スリッページ後も利益が出るか？',
    gate3: '利益 > $0.05 → 実行',
  },
  safuFund: {
    badge: '資産セキュリティ保証',
    title: 'Polywin SAFUファンド',
    titleHighlight: 'SAFUファンド',
    desc: 'オンチェーンロック準備金、透明でリアルタイム検証可能 — あなたの資産、我々が守ります',
    reserveLabel: 'Total Reserve · USDC · Ethereum Mainnet',
    verified: 'オンチェーン検証済み',
    mainDesc: 'Polywinチームはイーサリアムメインネットに1,000万USDCのSAFUセキュリティ準備基金をロックしました。',
    mainDescHighlight: '1,000万USDC',
    contractLabel: 'コントラクトアドレス',
    etherscanBtn: 'Etherscanで確認',
    stat0_label: '準備金規模',
    stat0_sub: 'USDC',
    stat1_label: 'オンチェーンロック率',
    stat1_sub: 'On-Chain',
    stat2_label: '検証可能',
    stat2_sub: 'Real-time',
    stat3_label: '過去の補償',
    stat3_val: '$0',
    stat3_sub: 'ゼロ損失記録',
    f0_title: 'オンチェーンロック',
    f0_desc: '資金の100%がイーサリアムメインネットのスマートコントラクトにロックされています',
    f1_title: '完全透明',
    f1_desc: '誰でもEtherscanを通じてリアルタイムで残高と取引履歴を確認できます',
    f2_title: '迅速な補償',
    f2_desc: 'セキュリティインシデント確認後72時間以内に補償プロセス開始',
    f3_title: '独立監査',
    f3_desc: '第三者セキュリティ機関が定期的にコントラクトコードを監査します',
  },
  cta: {
    badge: '今すぐ始める',
    title1: '使い始める',
    title2: 'Poly Ai Claw',
    title3: 'インテリジェンスエンジン',
    desc: 'コーディング不要 — 3分でAI戦略を設定',
    btn: 'AI-Claw起動',
    trust0: 'Polygon公式パートナー',
    trust1: '監査機関認定',
    trust2: '10,000+アクティブユーザー',
    trust3: '$50M+累計取引量',
  },
  footer: {
    tagline: 'Poly Ai Clawインテリジェンスエンジン',
    product: '製品',
    resources: 'リソース',
    social: 'ソーシャルメディア',
    link0: 'Poly AI-Clawアルゴリズム',
    link1: 'リスク管理システム',
    link2: 'データAPI',
    link3: '開発者ドキュメント',
    res0: 'チュートリアル',
    res1: '戦略事例',
    res2: 'ホワイトペーパー',
    res3: 'コミュニティフォーラム',
    copyright: '© 2026 PolyWin. All rights reserved.',
    privacy: 'プライバシーポリシー',
    terms: '利用規約',
  },
};
